import React, { useRef, useCallback } from 'react';
import { Autocomplete } from '@react-google-maps/api';
import { useGoogleMapsLoader } from '../hooks/useGoogleMapsLoader';

export function AddressInput({ value, onChange }) {
    const { isLoaded } = useGoogleMapsLoader();
    const autocompleteRef = useRef(null);

    const onLoad = useCallback((autocomplete) => {
        autocompleteRef.current = autocomplete;
    }, []);

    const onPlaceChanged = useCallback(() => {
        const place = autocompleteRef.current?.getPlace();
        if (place && place.geometry) {
            onChange({
                address: place.formatted_address || '',
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng(),
            });
        }
    }, [onChange]);

    const handleTextChange = useCallback((e) => {
        onChange({
            address: e.target.value,
            latitude: null,
            longitude: null,
        });
    }, [onChange]);

    if (isLoaded && window.google?.maps?.places) {
        return (
            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                <input
                    type="text"
                    placeholder="Enter address"
                    value={value || ''}
                    onChange={handleTextChange}
                />
            </Autocomplete>
        );
    }

    // Fallback: plain input if Maps SDK not loaded
    return (
        <input
            type="text"
            placeholder="Enter address"
            value={value || ''}
            onChange={handleTextChange}
        />
    );
}

export default AddressInput;
